import { useMemo, useRef, useSyncExternalStore } from "react";
import {
  getBoardPresentations,
  subscribeBoardPresentations,
} from "@/config/boardPresentation";
import { MIX_REGISTERED_SLUGS } from "@/config/browserBoard";
import {
  resolveMixCandidateSlugs,
  useMixStore,
} from "@/features/settings/stores/mixStore";

/** runtimeの既定板と保存済み追加板から、現在利用できる候補を返す。 */
export function useMixCandidateSlugs(
  registeredSlugs: readonly string[] = MIX_REGISTERED_SLUGS,
): readonly string[] {
  const addedBoards = useMixStore((state) => state.addedBoards);
  const unavailableSlugs = useMixStore((state) => state.unavailableSlugs);
  const boardSettings = useMixStore((state) => state.boardSettings);
  const presentations = useSyncExternalStore(
    subscribeBoardPresentations,
    getBoardPresentations,
    getBoardPresentations,
  );
  const candidatesRef = useRef<readonly string[]>([]);
  return useMemo(() => {
    const candidates = resolveMixCandidateSlugs(
      [...new Set([...registeredSlugs, ...Object.keys(presentations)])],
      addedBoards,
      unavailableSlugs,
      presentations,
      boardSettings,
    );
    // ON/OFF・取り分だけの変更では、候補を使う入力の状態を作り直さない。
    if (
      candidates.length === candidatesRef.current.length &&
      candidates.every((slug, index) => slug === candidatesRef.current[index])
    )
      return candidatesRef.current;
    candidatesRef.current = candidates;
    return candidates;
  }, [
    registeredSlugs,
    addedBoards,
    unavailableSlugs,
    presentations,
    boardSettings,
  ]);
}
